export const TM_LICENSE_PERSONAL = "personal";

export enum UserRole {
  Experimental = "Experimental",
  Pilot = "Pilot",
  Platinum = "Platinum",
  Premium = "Premium",
  Pro = "Pro",
  Public = "Public",
}
